import getSurvey from "./getSurvey.js";
import postPerformedSurvey from "./postPerformedSurvey.js";

const actions = {
    getSurvey: getSurvey,
    postPerformedSurvey: postPerformedSurvey
};

export default actions;
